import { Component, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalConstants } from '../../global-constants';

@Component({
  selector: 'app-perfil-hablamos',
  templateUrl: './perfil-hablamos.component.html',
  styleUrl: './perfil-hablamos.component.css'
})
export class PerfilHablamosComponent {
  @Input() misdatos!: any;
  @Input() perfil!: any;
  online: boolean = false;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.checkOnline(this.perfil.ID);
  }

  checkOnline(userId: number) {
    this.http.get<any>(
      GlobalConstants.urlServer + `wp-json/custom/v1/user-online/${userId}`
    ).subscribe(res => {
      this.online = res.online;
    });
  }

}
